import React from "react"
import { Link, navigate, graphql } from "gatsby"
import { Redirect } from '@reach/router'

import Bio from "../components/bio"
import Layout from "../components/layout"

import shop_1 from "../../content/assets/overview-shop-1@2x.jpg"
import shop_2 from "../../content/assets/overview-shop-2@2x.jpg"
import shop_3 from "../../content/assets/overview-shop-3@2x.jpg"
import whats_1 from "../../content/assets/overview-whats-1@2x.png"
import whats_2 from "../../content/assets/overview-whats-2@2x.png"
import whats_3 from "../../content/assets/overview-whats-3@2x.png"
import whats_4 from "../../content/assets/overview-whats-4@2x.png"
import portrait_1 from "../../content/assets/overview-portrait-1@2x.jpg"
import portrait_2 from "../../content/assets/overview-portrait-2@2x.jpg"
import portrait_3 from "../../content/assets/overview-portrait-3@2x.jpg"
import booth from "../../content/assets/overview-booth@2x.png"
import triangle from "../../content/assets/triangle@2x.png"

const Overview = ({ data, pageContext, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const { previous, next } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <main className="overview">

      <div className="copy">
          <h2>VRoid ファッションフェスタとは</h2>
          <p>
          VRoidのファッションに特化したバーチャルファッションの即売会を、オンラインで。 <br />VRoidファッションフェスタは、自分の作った服を知って欲しいと思っている服飾デザイナーさんと、自分に似合う好きな服を見つけたい人をつなぎます。  <br />服飾デザイナーさんのオススメしたい服のカタログと、撮影された写真のポートレートで<br />VRoidファッションを盛り上げます。

          </p>
      </div>

      <div className="whats">
          <h2>何をするの？</h2>
          <div className="column_box">
              <ul>
                  <li>
                  <p>VRoidだけの ファッションアイテムカタログ！</p>
                  <img src={whats_1} width="280" height="280" alt="" />
                  <span>VRoidだけのカタログに、あなたのイチオシ衣装や新作アイテムを載せてみませんか？VRoidファッションとの出会いの場を、カタログを通じて提供します。</span>
                  </li>
                  <li>
                  <p>あなたの写真をポートレートに 載せよう</p>
                  <img src={whats_2} width="280" height="280" alt="" />
                  <span>VRoidFFにショップが参加している服を着て写真を撮ってみませんか。公式サイトに掲載されちゃいます。方法は、Twitterに「#VRoidFF」を入れて写真をアップするだけ！</span>
                  </li>
                  <li>
                  <p>戦利品買ったぞ・訪問したぞ、シェアして応援！</p>
                  <img src={whats_3} width="280" height="280" alt="" />
                  <span>普段は買ったなんて言わないけど、お祭りに便乗して是非ショップのURLをシェアしてショップを応援してみませんか。シェアされた数を統計して発表します！</span>
                  </li>
                  <li>
                  <p>あなたのコーデをランウェイでお披露目！</p>
                  <img src={whats_4} width="280" height="280" alt="" />
                  <span>参加ショップのお洋服でコーディネート！公式配信ではランウェイを開催します。バーチャルフォト撮ってるみなさんも、とびっきり素敵なコーディネートして参加してみませんか？</span>
                  </li>
              </ul>
          </div>
      </div>

      <div className="datail">
      <h2>参加方法</h2>

          <div className="contents">
          <h3>VRoidだけのファッションアイテムカタログ！</h3>

          <h4>参加資格</h4>
          <p>VRoidの衣装や肌テクスチャ、髪、瞳など、ファッションに関わるアイテムをBOOTHに出している衣装クリエイターの方</p>
          <p className="column_txt">— お願い — <br/>
          新作を作って公開してみませんか？このイベントは、新作同時公開を一つの目玉として据えています。 <br/>
          同時に新作が公開されるため、普段服探しをしていない人だってあなたの新作を目にする機会になるのではと思います。<br/>
          新バリエーションの追加だけでも、新しいものがあればOK。是非この機会を使って、素敵な新作を作ってみましょう！<br/> 
          ※参加アイテムは、新作推奨ですが旧作のみでも参加は可能です
          </p>

          <h4>参加方法</h4>

          <div className="process_box">
          <ul>
              <li>
                  <p>1.応募</p>
                  <img src={shop_1} width="250" height="250" alt="" />
              </li>
              <li><img src={triangle} width="58" height="67" alt="" /></li>
              <li>
                  <p>2.出品準備</p>
                  <img src={shop_2} width="250" height="250" alt="" />
              </li>
              <li><img src={triangle} width="58" height="67" alt="" /></li>
              <li>
                  <p>3.一斉公開＆告知！</p>
                  <img src={shop_3} width="250" height="250" alt="" />
              </li>
          </ul>
          </div>

          <div className="column">
          <h5>1.応募（2020/12/5(土)締め切り）※応募は締め切りました</h5>
          下記フォームからお申し込みください。（この段階ではショップの登録のみとなります）<br/>
          ※登録にはgoogleアカウントが必要になります。<br/>
          ※登録前にショップのサムネールをご準備ください。サイズは200×200pxです。サムネールは登録後変更できません。<br/>
          ※応募・登録時に送信した画像・ショップやアイテムの情報は、VRoidファッションフェスタの公式ページ、Twitterアカウント、公式配信など、Vroidファッションフェスタ関連で使用します。応募いただいた段階で、こちらの利用を了承したものとします。<br/>
          </div>

          <div className="column">
          <h5>2.出品準備（〜2020/12/13(日) 23:59）</h5>
          ・洋服を作り、BOOTHに非公開で登録してください。 BOOTHのタグに 「VRoidFF」を入れてください。<br/>
          ・VRoidFFのカタログ用サムネールの制作をお願いします。（アイテム単位となります）<br/>
          ※応募・登録時に送信した画像・ショップやアイテムの情報は、VRoidファッションフェスタの公式ページ、Twitterアカウント、公式配信など、Vroidファッションフェスタ関連で使用します。応募いただいた段階で、こちらの利用を了承したものとします。<br/>
          ※ショップの商品登録前にショップのサムネールをご準備ください。サイズは1012×506（横長）です。サムネールは登録後変更できません。<br/>
          ・上記準備が完了したら、メールで送られているフォームに登録してください。
          </div>

          <div className="column">
          <h5>3.開催時間になったら一斉に公開＆告知！</h5>
          2020/12/20 20:00になったらBOOTHの参加アイテムを公開してください、（時間的に厳しい場合、開催期間内に公開をしてください。）
          </div>

          </div>

          <div className="contents">
          <h3>あなたの写真をポートレートに載せよう</h3>

          <h4>参加資格</h4>
          <p>参加アイテムのお洋服をお持ちで、その着用写真をTwitterにシェアしてくれた方。</p>

          <h4>参加方法</h4>

          <div className="process_box">
          <ul>
              <li>
                  <p>1.写真を撮影</p>
                  <img src={portrait_1} width="250" height="250" alt="" />
              </li>
              <li><img src={triangle} width="58" height="67" alt="" /></li>
              <li>
                  <p>2.ハッシュタグを使って<br/>ツイート</p>
                  <img src={portrait_2} width="250" height="250" alt="" />
              </li>
              <li><img src={triangle} width="58" height="67" alt="" /></li>
              <li>
                  <p>3.カタログ掲載！</p>
                  <img src={portrait_3} width="250" height="250" alt="" />
              </li>
          </ul>
          </div>

          <div className="column">
          <h5>1.写真を撮影</h5>
          VRoidFFに参加しているアイテムを着て、写真を撮影してください。<br/>
          </div>

          <div className="column">
          <h5>2.ハッシュタグ を使ってツイート</h5>
          「#VRoidFF」のハッシュタグ をつけて、Twitterにツイートしてください。<br/>
          ・写真はTwitterに投稿されたものを引用で掲載します。衣装のクレジットが必要なものはTwitter上に記載をお願いします。<br/>
          　参加アイテム以外でも、クレジットが必要な衣装を必要に応じて記載ください。<br/>
          ・「参加アイテム」は、カタログの<a href="/item">アイテムページ</a>に掲載されたアイテムとなります。<br />
          ・機械的に判断して掲載するため、トラブルなどございましたらTwitter側を削除お願いいたします。<br/>
          </div>

          <div className="column">
          <h5>3.ポートレートに写真掲載！</h5>
          参加衣装を着た写真はが掲載されます。いっぱい服を着て、いっぱい掲載してもらいましょう！公式配信で紹介されるかもしれません。
          </div>

          </div>

          <div className="contents">
          <h3>「戦利品買ったぞ」「訪問したぞ」をシェアして応援！</h3>

          <h4>参加資格</h4>
          <p>Twitterに参加アイテムのURLをシェアしてくれる方</p>

          <h4>参加方法</h4>


          <div className="column">
          <h5>1.戦利品を買ったときor訪問したときに、Twitterにシェアをしよう</h5>
          クリエイターさんは買ってくれたりしたことを知ることができると喜びます。<br/>
          普段はシェアしていなくても、このお祭り感に乗ってみてシェアしてみませんか。<br/>
          参加アイテムのBOOTHのURLを入れて、「#VRoidFF」をつけてTwitterにシェアするだけでOK！戦利品を買った後、訪問したあとなどがおすすめです。<br/><br/>
          <div class="box-center">
          <p>BOOTHのここからシェアすると簡単にシェアできるよ！</p>
          <img src={booth} width="600" height="200" alt="" />
          </div>
          </div>

          <div className="column">
          <h5>2.定期的に報告総数の公開</h5>
          VRoidファッションフェスタの公式アカウントにて、シェアの総数を公開します。
          </div>

          </div>


          <div className="contents">
          <h3>あなたのコーデをランウェイでお披露目！</h3>

          <h4>参加資格</h4>
          <p>Clusterで行われるVRoidファッションフェスタの公式配信にて、ランウェイを歩いていただける方募集しています</p>

          <h4>参加方法</h4>

          <div className="column">
          <h5>募集人数</h5>
          20名（応募が上回った場合、抽選の予定です）
          </div>

          <div className="column">
          <h5>実施日</h5>
          2021/1/3(日)20:00-<br/>
          （当日リハーサルを17:30-行う予定です）
          </div>

          <div className="column">
          <h5>応募期間※応募は締め切りました</h5>
          2020/12/20(日)20:00-2020/12/26(土)10:00<br/>
          </div>

          <div className="column">
          <h5>参加資格</h5>
          ・VRoidファッションフェスタのカタログページにあるアイテムをひとつ以上着用している方（コーディネートについてはおまかせします）<br/>
          ・Clusterのアカウントを所持いただいている方<br/>
          ・当日、指定の期日に参加いただける方
          </div>

          <div className="column">
          <h5>注意事項</h5>
          ・「参加アイテム」は、カタログの<a href="/item">アイテムページ</a>に掲載されたアイテムとなります。<br />
          ・テクスチャにより権利が異なりますので、権利をクリアにしていただいた上で応募ください。なお、参加アイテム以外に着用されている場合も同様となります。<br/>
          　利用範囲<br/>
          　　- VRoidファッションフェスタの公式配信でclusterとYoutubeで公開となります。<br/>
          　　- VRMデータはランウェイ参加該当者のclusterアカウントに保存した上で利用となります。<br/>
          　　- クレジットは公式Twitterに記載いたします。<br/>
          　　- 写真は、VRoidファッションフェスタ公式の範囲内で利用することがあります。<br/>
          　　- また、Clusterの来場者さんが写真を撮影し、無償の範囲内で各SNSに写真を掲載することについて、VRoidファッションフェスタは許諾するものとします。<br/>
          　　- VRoidファッションフェスタのYoutube公式配信によっての収益化はいたしません。<br/>
          ・VRoidモデル以外のモデルへの着用での応募に関しましては、スタッフまでお問い合わせください。<br/>
          ・Cluster用で応募コーディネートのVRMを作って頂き、それを各自のアカウントにアップロードしていただきます。<br/>
          ・VRoidファッションフェスタ側ではVRMデータを受け取ることはありません。<br/>
          ・今回のclusterでの配信は、今回はクラスター社の許可を得た上で開催させていただいております。
          </div>
          </div>



      </div>

      </main>
    </Layout>
  )
}

export default Overview

export const pageQuery = graphql`
query OverviewQuery {
  site {
    siteMetadata {
      title
    }
  }
}
`
